import type { ReviewRow } from "@/components/ui/transaction-review-contract";
import { readerRows } from "@/features/wallet/v2/readerRows";

/*
 * THE NFT REVIEW AS THE HOLDER READS IT — `buildReviewRows` documents every
 * figure (which endpoint publishes no fee, why the net cannot be computed,
 * that no signature is requested); the v2 dialog shows only what can be acted
 * on. Rows that can never hold a figure here are left out (platform fee, gas,
 * the net — it needs both — and the approval line), and the balance and the
 * expiry where this path has none (accepting draws on no balance, a listing
 * never expires) — then the money surfaces' own reader: one plain sentence at most, a figure not known yet is a dash.
 * The figures themselves are untouched.
 */
const NEVER_A_FIGURE = new Set(["platform-fee", "gas", "net", "approval"]);
const ONLY_WITH_A_FIGURE = new Set(["wallet-balance", "expiration"]);

export function nftReaderRows(rows: ReviewRow[], lang: "fa" | "en"): ReviewRow[] {
  return readerRows(rows.filter((r) => !NEVER_A_FIGURE.has(r.id) && !(ONLY_WITH_A_FIGURE.has(r.id) && r.value.kind === "unavailable")), lang);
}
